import { SECT_TYPE, SECT_FILER, SECT_APPLICANT, GENERAL_FIELDS } from './artsGeneral';
import { SECT_PE, SECT_EVENT_DETAILS, SECT_EVENT_VENUE, SECT_PERFORMER, SECT_DOCS, EVENT_FIELDS } from './artsEvents';
import { SECT_PE_ON_GOING, EVENT_PE_FIELDS } from './artsPE';
import { SECT_PERFORMER_ON_GOING, EVENT_PERFORMER_FIELDS } from './artsPerformer';
import { SECT_EVENT_ON_GOING, EVENT_TYPES_FIELDS } from './artsEventTypes';

import { SECT_ORGANISATION, ORGANISATION_FIELDS } from './pubOrganisation';
import { SECT_PUB_DETAILS, PUBLICATION_FIELDS } from './pubDetails';
import { CONTACT_DETAILS_FIELDS, CONTACT_APPLICANT } from './artsContact';
import { PUB_CONTACT_DETAILS_FIELDS, CONTACT_PUB } from './pubContact';
import PUBLICATION_TITLE from './pubTitle';
import AEC_DOWNLOAD from './aecDownloadFiles';
import SUMMARY, { SUMMARY_AEL, SUMMARY_LICENCE, SUMMARY_LICENCE_TAB } from './Summary';
import { LICENCE_ORGANISATION } from './Licence/licenceOrganisation';
import { EXPRESSLETTER } from './Licence/MyLicence/expressLetter';
import { AIRCRAFTLICENCE } from './Licence/MyLicence/aircraftLicence';
import { CONTACT_DETAILS } from './Licence/contactDetails';
import Licence_DOWNLOAD from './Licence/licenceDownload';
import { AEL_GENERAL_FIELDS } from './Licence/MyApplication/aelGeneral';
import { AEL_EVENT_FIELDS } from './Licence/MyApplication/aelEvent';
import { MYLICENCE_LICENCE_ORGANISATION } from './Licence/MyLicence/licenceOrganisation';
import { LICENCE_PAYMENT } from './Licence/MyLicence/licencePayment';
import { MYLICENCE_LOCALISEDNETWORK } from './Licence/MyLicence/localisedNetwork';
import { CANCEL_AIRCRAFTLICENCE_APPLICATION } from './Licence/MyApplication/cancel-AircraftApplication';
import { AMEND_AIRCRAFTLICENCE_APPLICATION } from './Licence/MyApplication/amend-AircraftApplication';
import { NEW_AIRCRAFTLICENCE_APPLICATION } from './Licence/MyApplication/new-AircraftApplication';
import { NEW_EXPRESSLETTER_APPLICATION } from './Licence/MyApplication/new-ExpressLetter';
import { NEW_MYAPPLICATION_LOCALISEDNETWORK } from './Licence/MyApplication/new-LocalisedNetwork';
import { RENEW_AIRCRAFTLICENCE_APPLICATION } from './Licence/MyApplication/renew-AircraftApplication';
import { AMATEUR_STATION_APPLICATION } from './Licence/MyLicence/amateurStationLicence';
import { SSL_LICENCE } from './Licence/MyLicence/SSLLicence';
import { AMEND_SSL_LICENCE } from './Licence/MyLicence/amend-SSLLicence';
import { GRS_LICENCE } from './Licence/MyLicence/GRSLicence';
import { AMEND_GRS_LICENCE } from './Licence/MyLicence/amend-GRSLicence';
import { LRS_LICENCE } from './Licence/MyLicence/LRSLicence';
import { AMEND_LRS_LICENCE } from './Licence/MyLicence/amend-LRSLicence';
import { LPN_LICENCE } from './Licence/MyLicence/LPNLicence';
import { AMEND_LPN_LICENCE } from './Licence/MyLicence/amend-LPNLicence';
import { PMN_LICENCE } from './Licence/MyLicence/PMNLicence';
import { AMEND_PMN_LICENCE } from './Licence/MyLicence/amend-PMNLicence';
import { SCS_LICENCE } from './Licence/MyLicence/SCSLicence';
import { AMEND_SCS_LICENCE } from './Licence/MyLicence/amend-SCSLicence';
import { SSOC_LICENCE } from './Licence/MyLicence/SSOCLicence';
import { AMEND_SSOC_LICENCE } from './Licence/MyLicence/amend-SSOCLicence';
import APPLICATION_WITHDRAW from './aecWithdraw';
import APPLICATION_DELETE from './applicationDelete';
import MYLICENCE_DOWNLOAD from './Licence/MyLicence/licenceDownload';
import { CANCELLED_LICENCE } from './Licence/MyLicence/cancelledLicence';
import { CANCEL_LICENCE_APPLICATION } from './Licence/MyApplication/cancelLicence';
import { RENEW_LICENCE_APPLICATION } from './Licence/MyApplication/renewLicence';
import { AMEND_LICENCE_APPLICATION } from './Licence/MyApplication/amendLicence';
import { SSL_APPLICATION } from './Licence/MyApplication/SSLApplication';
import { AMEND_SSL_APPLICATION } from './Licence/MyApplication/amend-SSLApplication';
import { GRS_APPLICATION } from './Licence/MyApplication/GRSApplication';
import { AMEND_GRS_APPLICATION } from './Licence/MyApplication/amend-GRSApplication';
import { LRS_APPLICATION } from './Licence/MyApplication/LRSApplication';
import { AMEND_LRS_APPLICATION } from './Licence/MyApplication/amend-LRSApplication';
import { LPN_APPLICATION } from './Licence/MyApplication/LPNApplication';
import { AMEND_LPN_APPLICATION } from './Licence/MyApplication/amend-LPNApplication';
import { PMN_APPLICATION } from './Licence/MyApplication/PMNApplication';
import { AMEND_PMN_APPLICATION } from './Licence/MyApplication/amend-PMNApplication';
import { SCS_APPLICATION } from './Licence/MyApplication/SCSApplication';
import { AMEND_SCS_APPLICATION } from './Licence/MyApplication/amend-SCSApplication';
import { SSOC_APPLICATION } from './Licence/MyApplication/SSOCApplication';
import { AMEND_SSOC_APPLICATION } from './Licence/MyApplication/amend-SSOCApplication';

import { FILMS } from './Films';
import { FILMS_PENDING_KDM, RCA_PENDING_KDM } from './Films/pendingKDM';
import { VIDEO_GAMES, DECLARATION_OF_INTERACTIVE_SOFTWARE } from './VideoGames';

import { TDI_APPLICATION } from './Licence/MyApplication/TDIApplication';
import { AMEND_TDI_APPLICATION } from './Licence/MyApplication/amend-TDIApplication';
import { TDI_LICENCE } from './Licence/MyLicence/TDILicence';
import { AMEND_TDI_LICENCE } from './Licence/MyLicence/amend-TDILicence';
import { TDC_LICENCE } from './Licence/MyLicence/TDCLicence';
import { AMEND_TDC_LICENCE } from './Licence/MyLicence/amend-TDCLicence';
import { TDC_APPLICATION } from './Licence/MyApplication/TDCApplication';
import { AMEND_TDC_APPLICATION } from './Licence/MyApplication/amend-TDCApplication';
import { GER_APPLICATION } from './Licence/MyApplication/GERApplication';
import { AMEND_GER_APPLICATION } from './Licence/MyApplication/amend-GERApplication';
import { GER_LICENCE } from './Licence/MyLicence/GERLicence';
import { AMEND_GER_LICENCE } from './Licence/MyLicence/amend-GERLicence';
import { GERCB_APPLICATION } from './Licence/MyApplication/GERCBApplication';
import { AMEND_GERCB_APPLICATION } from './Licence/MyApplication/amend-GERCBApplication';
import { GERCB_LICENCE } from './Licence/MyLicence/GERCBLicence';
import { AMEND_GERCB_LICENCE } from './Licence/MyLicence/amend-GERCBLicence';
import { SER_APPLICATION } from './Licence/MyApplication/SERApplication';
import { AMEND_SER_APPLICATION } from './Licence/MyApplication/amend-SERApplication';
import { SER_LICENCE } from './Licence/MyLicence/SERLicence';
import { AMEND_SER_LICENCE } from './Licence/MyLicence/amend-SERLicence';
import { ESER_APPLICATION } from './Licence/MyApplication/ESERApplication';
import { AMEND_ESER_APPLICATION } from './Licence/MyApplication/amend-ESERApplication';
import { ESER_LICENCE } from './Licence/MyLicence/ESERLicence';
import { AMEND_ESER_LICENCE } from './Licence/MyLicence/amend-ESERLicence';
import { COFC_APPLICATION } from './Licence/MyApplication/COFCApplication';
import { AMEND_COFC_APPLICATION } from './Licence/MyApplication/amend-COFCApplication';
import { COFC_LICENCE } from './Licence/MyLicence/COFCLicence';
import { AMEND_COFC_LICENCE } from './Licence/MyLicence/amend-COFCLicence';
import { PPL_APPLICATION } from './Licence/MyApplication/PPLApplication';
import { AMEND_PPL_APPLICATION } from './Licence/MyApplication/amend-PPLApplication';
import { PPL_LICENCE } from './Licence/MyLicence/PPLLicence';
import { AMEND_PPL_LICENCE } from './Licence/MyLicence/amend-PPLLicence';
import { NPP_APPLICATION } from './Licence/MyApplication/NPPApplication';
import { AMEND_NPP_APPLICATION } from './Licence/MyApplication/amend-NPPApplication';
import { NPP_LICENCE } from './Licence/MyLicence/NPPLicence';
import { AMEND_NPP_LICENCE } from './Licence/MyLicence/amend-NPPLicence';
import { FWN_APPLICATION } from './Licence/MyApplication/FWNApplication';
import { AMEND_FWN_APPLICATION } from './Licence/MyApplication/amend-FWNApplication';
import { FWN_LICENCE } from './Licence/MyLicence/FWNLicence';
import { AMEND_FWN_LICENCE } from './Licence/MyLicence/amend-FWNLicence';
import { WPN_APPLICATION } from './Licence/MyApplication/WPNApplication';
import { AMEND_WPN_APPLICATION } from './Licence/MyApplication/amend-WPNApplication';
import { WPN_LICENCE } from './Licence/MyLicence/WPNLicence';
import { AMEND_WPN_LICENCE } from './Licence/MyLicence/amend-WPNLicence';
import { ESL_APPLICATION } from './Licence/MyApplication/ESLApplication';
import { AMEND_ESL_APPLICATION } from './Licence/MyApplication/amend-ESLApplication';
import { ESL_LICENCE } from './Licence/MyLicence/ESLLicence';
import { AMEND_ESL_LICENCE } from './Licence/MyLicence/amend-ESLLicence';
import { SPS_APPLICATION } from './Licence/MyApplication/SPSApplication';
import { AMEND_SPS_APPLICATION } from './Licence/MyApplication/amend-SPSApplication';
import { SPS_LICENCE } from './Licence/MyLicence/SPSLicence';
import { AMEND_SPS_LICENCE } from './Licence/MyLicence/amend-SPSLicence';
import { TTF_APPLICATION } from './Licence/MyApplication/TTFApplication';
import { AMEND_TTF_APPLICATION } from './Licence/MyApplication/amend-TTFApplication';
import { TTF_LICENCE } from './Licence/MyLicence/TTFLicence';
import { AMEND_TTF_LICENCE } from './Licence/MyLicence/amend-TTFLicence';
import { TUF_APPLICATION } from './Licence/MyApplication/TUFApplication';
import { AMEND_TUF_APPLICATION } from './Licence/MyApplication/amend-TUFApplication';
import { TUF_LICENCE } from './Licence/MyLicence/TUFLicence';
import { AMEND_TUF_LICENCE } from './Licence/MyLicence/amend-TUFLicence';
import { SBOI_APPLICATION } from './Licence/MyApplication/SBOIApplication';
import { AMEND_SBOI_APPLICATION } from './Licence/MyApplication/amend-SBOIApplication';
import { SBOI_LICENCE } from './Licence/MyLicence/SBOILicence';
import { AMEND_SBOI_LICENCE } from './Licence/MyLicence/amend-SBOILicence';
import { TVRO_APPLICATION } from './Licence/MyApplication/TVROApplication';
import { AMEND_TVRO_APPLICATION } from './Licence/MyApplication/amend-TVROApplication';
import { TVRO_LICENCE } from './Licence/MyLicence/TVROLicence';
import { AMEND_TVRO_LICENCE } from './Licence/MyLicence/amend-TVROLicence';
import { TCDWCL_APPLICATION } from './Licence/MyApplication/TCDWCLApplication';
import { AMEND_TCDWCL_APPLICATION } from './Licence/MyApplication/amend-TCDWCLApplication';
import { TCDWCL_LICENCE } from './Licence/MyLicence/TCDWCLLicence';
import { AMEND_TCDWCL_LICENCE } from './Licence/MyLicence/amend-TCDWCLLicence';

// FDEL
import { FDEL_APPLICATION } from './Licence/MyApplication/FDELApplication';
import { AMEND_FDEL_APPLICATION } from './Licence/MyApplication/amend-FDELApplication';
import { FDEL_LICENCE } from './Licence/MyLicence/FDELLicence';
import { AMEND_FDEL_LICENCE } from './Licence/MyLicence/amend-FDELLicence';
import { CASE_TYPE_ID } from 'common/constants';
import { TWICL_APPLICATION } from './Licence/MyApplication/TWICLApplication';
import { AMEND_TWICL_APPLICATION } from './Licence/MyApplication/amend-TWICLApplication';
import { TWICL_LICENCE } from './Licence/MyLicence/TWICLLicence';
import { AMEND_TWICL_LICENCE } from './Licence/MyLicence/amend-TWICLLicence';
import { TWCCL_APPLICATION } from './Licence/MyApplication/TWCCLApplication';
import { AMEND_TWCCL_APPLICATION } from './Licence/MyApplication/amend-TWCCLApplication';
import { TWCCL_LICENCE } from './Licence/MyLicence/TWCCLLicence';
import { AMEND_TWCCL_LICENCE } from './Licence/MyLicence/amend-TWCCLLicence';
import { TF_APPLICATION } from './Licence/MyApplication/TFApplication';
import { AMEND_TF_APPLICATION } from './Licence/MyApplication/amend-TFApplication';
import { TF_LICENCE } from './Licence/MyLicence/TFLicence';
import { AMEND_TF_LICENCE } from './Licence/MyLicence/amend-TFLicence';
import { EXB_APPLICATION } from './Licence/MyApplication/EXBApplication';
import { EXB_LICENCE } from './Licence/MyLicence/EXBLicence';
import { AMEND_EXB_LICENCE } from './Licence/MyLicence/amend-EXBLicence';
import { AMEND_EXB_APPLICATION } from './Licence/MyApplication/amend-EXBApplication';
import { EXBF_APPLICATION } from './Licence/MyApplication/EXBFApplication';
import { AMEND_EXBF_APPLICATION } from './Licence/MyApplication/amend-EXBFApplication';
import { EXBF_LICENCE } from './Licence/MyLicence/EXBFLicence';
import { AMEND_EXBF_LICENCE } from './Licence/MyLicence/amend-EXBFLicence';
import { SBOC_APPLICATION, SBOC_SERVICES as SBOC_APPLICATION_SERVICES } from './Licence/MyApplication/SBOCApplication';
import { AMEND_SBOC_APPLICATION } from './Licence/MyApplication/amend-SBOCApplication';
import { SBOC_LICENCE, SBOC_SERVICES as SBOC_LICENCE_SERVICES } from './Licence/MyLicence/SBOCLicence';
import { AMEND_SBOC_LICENCE } from './Licence/MyLicence/amend-SBOCLicence';
import { ISP_APPLICATION } from './Licence/MyApplication/ISPApplication';
import { AMEND_ISP_APPLICATION } from './Licence/MyApplication/amend-ISPApplication';
import { ISP_LICENCE } from './Licence/MyLicence/ISPLicence';
import { AMEND_ISP_LICENCE } from './Licence/MyLicence/amend-ISPLicence';

import { ROE_APPLICATION_FIELDS } from './submodules/roe/roeApplicationDetails';
import { AMEND_ACA_APPLICATION } from './Licence/MyApplication/amend-ACAApplication';
import { AMEND_ACA_LICENCE } from './Licence/MyLicence/amend-ACALicence';
import { CANCELLATION_FIELDS, CANCELLATION_FIELDS_AA } from './Licence/MyApplication/cancelApplication';
import {
    GENERAL_FIELDS as OTHER_GENERAL_FIELDS,
    SECT_TYPE as OTHER_SECT_TYPE,
    SECT_FILER as OTHER_SECT_FILER,
    SECT_APPLICANT as OTHER_SECT_APPLICANT,
    SECT_ADDRESS as OTHER_SECT_ADDRESS,
    SECT_COMPANY as OTHER_SECT_COMPANY
} from './submodules/otherGeneral';
import { CONTACT_DETAILS as OTHER_CONTACT_DETAILS } from './submodules/contactDetails';
import { ACA_GENERAL_FIELDS } from './submodules/aca/acaGeneral';
import { ACA_APPLICATION_FIELDS } from './submodules/aca/acaApplicationDetails';
import { ACA_AMEND_APPLICATION_FIELDS } from './submodules/aca/acaAmendApplicationDetails';
import { ACA_RENEW_APPLICATION_FIELDS } from './submodules/aca/acaRenewApplicationDetails';
import { AA_APPLICATION_FIELDS } from './submodules/aa/aaApplicationDetails';
import { AA_GENERAL_FIELDS } from './submodules/aa/aaGeneral';
import { AA_CONTACT_DETAILS } from './submodules/aa/aaContactDetails';

const INDUSTRIES = [
    {
        title: 'Arts',
        steps: ['Application Details', 'Review', 'Make Payment'],
        caseType: 'IMDA-IRIS-Work-Arts',
        actionSave: 'pyUpdateCaseDetails',
        actionCollect: 'CollectArtDetails',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'general',
                title: 'Applicant/Filer Details',
                fields: GENERAL_FIELDS,
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'event',
                title: 'Event Details',
                fieldIDTitle: 'event-details-event-title',
                multiple: true,
                fields: EVENT_FIELDS,
                submitBtn: { id: 'review', title: 'Review' },
                addBtn: { id: 'add-new', title: 'Add New Event' }
            },
            {
                formID: 'application-delete',
                title: '',
                fields: APPLICATION_DELETE
            }
        ]
    },
    {
        title: 'Arts',
        steps: [],
        caseType: 'IMDA-IRIS-Work-Events',
        actionSave: 'UpdateCase',
        actionCollect: 'EventClassification',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'event-pe',
                title: '',
                fields: EVENT_PE_FIELDS
            },
            {
                formID: 'event-performer',
                title: '',
                fields: EVENT_PERFORMER_FIELDS
            },
            {
                formID: 'event-types',
                title: '',
                fields: EVENT_TYPES_FIELDS
            },
            {
                formID: 'contact-details',
                title: '',
                fields: CONTACT_DETAILS_FIELDS
            },
            {
                formID: 'event',
                title: 'Event Details',
                fieldIDTitle: 'event-details-event-title',
                multiple: true,
                fields: EVENT_FIELDS
            },
            {
                formID: 'general',
                title: 'Applicant/Filer Details',
                fields: GENERAL_FIELDS
            },
            {
                formID: 'download',
                title: '',
                fields: AEC_DOWNLOAD
            },
            {
                formID: 'application-withdraw',
                title: '',
                fields: APPLICATION_WITHDRAW
            },
            {
                formID: 'summary',
                title: '',
                fields: SUMMARY
            }
        ]
    },
    {
        title: 'Publications',
        steps: [],
        caseType: 'IMDA-IRIS-Work-PublicationTitles',
        actionSave: 'EditCaseDetails',
        actionCollect: 'CollectDetails',
        actionReview: 'ReviewPublicationScreen',
        forms: [
            {
                formID: 'contact-details',
                title: '',
                fields: PUB_CONTACT_DETAILS_FIELDS
            },
            {
                formID: 'organisation',
                title: 'Applicant/Company Details',
                fields: ORGANISATION_FIELDS
            },
            {
                formID: 'publication',
                title: 'Publication Details',
                fieldIDTitle: 'publication-details-publication-title',
                fields: PUBLICATION_TITLE,
                multiple: true
            },
            {
                formID: 'summary',
                title: '',
                fields: SUMMARY
            },
            {
                formID: 'application-delete',
                title: '',
                fields: APPLICATION_DELETE
            },
            {
                formID: 'application-withdraw',
                title: '',
                fields: APPLICATION_WITHDRAW
            }
        ]
    },
    {
        title: 'Publications',
        steps: ['Application Details', 'Review'],
        caseType: 'IMDA-IRIS-Work-Publication',
        actionSave: 'pyUpdateCaseDetails',
        actionCollect: 'CollectDetails',
        actionReview: 'ReviewPublicationScreen',
        forms: [
            {
                formID: 'organisation',
                title: 'Applicant/Company Details',
                fields: ORGANISATION_FIELDS,
                submitBtn: { id: 'submit-org', title: 'Next Section' }
            },
            {
                formID: 'publication',
                title: 'Publication Details',
                fieldIDTitle: 'publication-details-publication-title',
                fields: PUBLICATION_FIELDS,
                multiple: true,
                submitBtn: { id: 'submit-org', title: 'Review' },
                addBtn: { id: 'add-new', title: 'Add New Publication' },
                maxForm: 20,
                maxMessage: 'Maximum of 20 Publication Cases per Application.'
            },
            {
                formID: 'application-delete',
                title: '',
                fields: APPLICATION_DELETE
            }
        ]
    },
    {
        title: 'Others',
        steps: ['Application Details', 'Review'],
        caseType: 'IMDA-IRIS-Work-LICApplication-ROE',
        actionSave: 'pyUpdateCaseDetails',
        actionCollect: 'CollectROEDetails',
        actionReview: 'ReviewROEScreen',
        forms: [
            {
                formID: 'general',
                title: 'Applicant/Filer Details',
                fields: OTHER_GENERAL_FIELDS,
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'contact-billing-details',
                title: 'Billing Details',
                fields: OTHER_CONTACT_DETAILS,
                submitBtn: { id: 'submit-billing-details', title: 'Next Section' }
            },
            {
                formID: 'application-details',
                title: 'Application Details',
                fields: ROE_APPLICATION_FIELDS,
                submitBtn: { id: 'review', title: 'Review' }
            },
            {
                formID: 'licence_download',
                title: '',
                fields: Licence_DOWNLOAD
            },
            {
                formID: 'application-withdraw',
                title: '',
                fields: APPLICATION_WITHDRAW
            },
            {
                formID: 'application-delete',
                title: '',
                fields: APPLICATION_DELETE
            }
        ]
    },
    {
        title: 'Others',
        steps: ['Application Details', 'Review', 'Make Payment'],
        caseType: 'IMDA-IRIS-Work-LICApplication-ACA',
        actionSave: 'pyUpdateCaseDetails',
        actionCollect: 'CollectROEDetails',
        actionReview: 'ReviewROEScreen',
        forms: [
            {
                formID: 'general',
                title: 'Applicant/Filer Details',
                fields: ACA_GENERAL_FIELDS,
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'contact-billing-details',
                title: 'Billing Details',
                fields: OTHER_CONTACT_DETAILS,
                submitBtn: { id: 'submit-billing-details', title: 'Next Section' }
            },
            {
                formID: 'application-details',
                title: 'Application Details',
                fields: ACA_APPLICATION_FIELDS,
                submitBtn: { id: 'review', title: 'Review' }
            },
            {
                formID: 'licence_download',
                title: '',
                fields: Licence_DOWNLOAD
            },
            {
                formID: 'application-withdraw',
                title: '',
                fields: APPLICATION_WITHDRAW
            },
            {
                formID: 'application-delete',
                title: '',
                fields: APPLICATION_DELETE
            }
        ]
    },
    {
        title: 'Licence',
        steps: [],
        caseType: 'IMDA-IRIS-Work-LICApplication-ACA-VIEW',
        actionSave: 'UpdateCase',
        actionCollect: 'EventClassification',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'summary',
                title: 'Application Summary',
                fields: SUMMARY_LICENCE
            },
            {
                formID: 'general',
                title: 'Applicant/Filer Details',
                fields: ACA_GENERAL_FIELDS
            },
            {
                formID: 'contact-billing-details',
                title: 'Billing Details',
                fields: OTHER_CONTACT_DETAILS
            },
            {
                formID: 'application-details',
                title: 'Application Details',
                fields: ACA_APPLICATION_FIELDS
            }
        ]
    },
    {
        title: 'Licence',
        steps: [],
        caseType: 'IMDA-IRIS-Work-LICApplication-ACA-AMEND-VIEW',
        actionSave: 'UpdateCase',
        actionCollect: 'EventClassification',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'summary',
                title: 'Application Summary',
                fields: SUMMARY_LICENCE
            },
            {
                formID: 'general-amend',
                title: 'Applicant/Filer Details',
                fields: ACA_GENERAL_FIELDS
            },
            {
                formID: 'contact-billing-details-amend',
                title: 'Billing Details',
                fields: OTHER_CONTACT_DETAILS
            },
            {
                formID: 'application-details-amend',
                title: 'Application Details',
                fields: AMEND_ACA_APPLICATION
            }
        ]
    },
    {
        title: 'Amend',
        steps: ['Application Details', 'Review'],
        caseType: 'IMDA-IRIS-Work-LICApplication-ACA-AMEND',
        actionSave: 'pyUpdateCaseDetails',
        actionCollect: 'CollectROEDetails',
        actionReview: 'ReviewROEScreen',
        forms: [
            {
                formID: 'general-amend',
                title: 'Applicant/Filer Details',
                fields: ACA_GENERAL_FIELDS,
                submitBtn: { id: 'submit-general-amend', title: 'Next Section' }
            },
            {
                formID: 'contact-billing-details-amend',
                title: 'Billing Details',
                fields: OTHER_CONTACT_DETAILS,
                submitBtn: { id: 'submit-billing-details-amend', title: 'Next Section' }
            },
            {
                formID: 'application-details-amend',
                title: 'Application Details',
                fields: ACA_AMEND_APPLICATION_FIELDS,
                submitBtn: { id: 'review-amend', title: 'Review' }
            }
        ]
    },
    {
        title: 'Cancel',
        steps: ['Application Details', 'Review'],
        caseType: 'IMDA-IRIS-Work-LICApplication-ACA-CANCEL',
        actionSave: 'pyUpdateCaseDetails',
        actionCollect: 'CollectROEDetails',
        actionReview: 'ReviewROEScreen',
        forms: [
            {
                formID: 'general-cancel',
                title: 'Applicant/Filer Details',
                fields: ACA_GENERAL_FIELDS,
                submitBtn: { id: 'submit-general-cancel', title: 'Next Section' }
            },
            {
                formID: 'cancellation-details',
                title: 'Cancellation Details',
                fields: CANCELLATION_FIELDS,
                submitBtn: { id: 'review-cancel', title: 'Review' }
            }
        ]
    },
    {
        title: 'Renew',
        steps: ['Application Details', 'Review', 'Make Payment'],
        caseType: 'IMDA-IRIS-Work-LICApplication-ACA-RENEW',
        actionSave: 'pyUpdateCaseDetails',
        actionCollect: 'CollectROEDetails',
        actionReview: 'ReviewROEScreen',
        forms: [
            {
                formID: 'general-renew',
                title: 'Applicant/Filer Details',
                fields: ACA_GENERAL_FIELDS,
                submitBtn: { id: 'submit-general-renew', title: 'Next Section' }
            },
            {
                formID: 'contact-billing-details-renew',
                title: 'Billing Details',
                fields: OTHER_CONTACT_DETAILS,
                submitBtn: { id: 'submit-billing-details-renew', title: 'Next Section' }
            },
            {
                formID: 'application-details-renew',
                title: 'Application Details',
                fields: ACA_RENEW_APPLICATION_FIELDS,
                submitBtn: { id: 'review-renew', title: 'Review' }
            }
        ]
    },
    {
        title: 'Renew',
        steps: ['Application Details', 'Review'],
        caseType: 'IMDA-IRIS-Work-LICApplication-ACA-RENEW-NOPAY',
        actionSave: 'pyUpdateCaseDetails',
        actionCollect: 'CollectROEDetails',
        actionReview: 'ReviewROEScreen',
        forms: [
            {
                formID: 'general-renew-nopay',
                title: 'Applicant/Filer Details',
                fields: ACA_GENERAL_FIELDS,
                submitBtn: { id: 'submit-general-renew-nopay', title: 'Next Section' }
            },
            {
                formID: 'contact-billing-details-renew-nopay',
                title: 'Billing Details',
                fields: OTHER_CONTACT_DETAILS,
                submitBtn: { id: 'submit-billing-details-renew-nopay', title: 'Next Section' }
            },
            {
                formID: 'application-details-renew-nopay',
                title: 'Application Details',
                fields: ACA_RENEW_APPLICATION_FIELDS,
                submitBtn: { id: 'review-renew-nopay', title: 'Review' }
            }
        ]
    },
    {
        title: 'Licence',
        steps: [],
        caseType: 'IMDA-IRIS-Work-LICApplication-ACA-RENEW-VIEW',
        actionSave: 'UpdateCase',
        actionCollect: 'EventClassification',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'summary',
                title: 'Application Summary',
                fields: SUMMARY_LICENCE
            },
            {
                formID: 'general-renew',
                title: 'Applicant/Filer Details',
                fields: ACA_GENERAL_FIELDS
            },
            {
                formID: 'contact-billing-details-renew',
                title: 'Billing Details',
                fields: OTHER_CONTACT_DETAILS
            },
            {
                formID: 'application-details-renew',
                title: 'Application Details',
                fields: ACA_RENEW_APPLICATION_FIELDS
            }
        ]
    },
    {
        title: 'Licence',
        steps: [],
        caseType: 'IMDA-IRIS-Work-LICApplication-ROE-VIEW',
        actionSave: 'UpdateCase',
        actionCollect: 'EventClassification',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'summary',
                title: 'Application Summary',
                fields: SUMMARY_LICENCE
            },
            {
                formID: 'general',
                title: 'Applicant/Filer Details',
                fields: OTHER_GENERAL_FIELDS
            },
            {
                formID: 'contact-billing-details',
                title: 'Billing Details',
                fields: OTHER_CONTACT_DETAILS
            },
            {
                formID: 'application-details',
                title: 'Application Details',
                fields: ROE_APPLICATION_FIELDS
            }
        ]
    },
    {
        title: 'Others',
        steps: ['Application Details', 'Review'],
        caseType: 'IMDA-IRIS-Work-LICApplication-AA',
        actionSave: 'pyUpdateCaseDetails',
        actionCollect: 'CollectROEDetails',
        actionReview: 'ReviewAAScreen',
        forms: [
            {
                formID: 'general',
                title: 'Applicant/Filer Details',
                fields: AA_GENERAL_FIELDS,
                submitBtn: { id: 'submit-general', title: 'Next Section' }
            },
            {
                formID: 'contact-billing-details',
                title: 'Billing Details',
                fields: AA_CONTACT_DETAILS,
                submitBtn: { id: 'submit-billing-details', title: 'Next Section' }
            },
            {
                formID: 'application-details',
                title: 'Application Details',
                fields: AA_APPLICATION_FIELDS,
                submitBtn: { id: 'review', title: 'Review' }
            },
            {
                formID: 'licence_download',
                title: '',
                fields: Licence_DOWNLOAD
            },
            {
                formID: 'application-withdraw',
                title: '',
                fields: APPLICATION_WITHDRAW
            },
            {
                formID: 'application-delete',
                title: '',
                fields: APPLICATION_DELETE
            }
        ]
    },
    {
        title: 'Licence',
        steps: [],
        caseType: 'IMDA-IRIS-Work-LICApplication-AA-VIEW',
        actionSave: 'UpdateCase',
        actionCollect: 'EventClassification',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'summary',
                title: 'Application Summary',
                fields: SUMMARY_LICENCE
            },
            {
                formID: 'general',
                title: 'Applicant/Filer Details',
                fields: AA_GENERAL_FIELDS
            },
            {
                formID: 'contact-billing-details',
                title: 'Billing Details',
                fields: AA_CONTACT_DETAILS
            },
            {
                formID: 'application-details',
                title: 'Application Details',
                fields: AA_APPLICATION_FIELDS
            }
        ]
    },
    {
        title: 'Cancel',
        steps: ['Application Details', 'Review'],
        caseType: 'IMDA-IRIS-Work-LICApplication-AA-CANCEL',
        actionSave: 'pyUpdateCaseDetails',
        actionCollect: 'CollectROEDetails',
        actionReview: 'ReviewROEScreen',
        forms: [
            {
                formID: 'general-cancel',
                title: 'Applicant/Filer Details',
                fields: AA_GENERAL_FIELDS,
                submitBtn: { id: 'submit-general-cancel', title: 'Next Section' }
            },
            {
                formID: 'cancellation-details',
                title: 'Cancellation Details',
                fields: CANCELLATION_FIELDS_AA,
                submitBtn: { id: 'review-cancel', title: 'Review' }
            }
        ]
    },
    {
        title: 'Licence',
        steps: [],
        caseType: 'IMDA-IRIS-Work-LICApplication',
        actionSave: 'UpdateCase',
        actionCollect: 'EventClassification',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'summary',
                title: '',
                fields: SUMMARY_LICENCE
            },
            {
                formID: 'summary-ael',
                title: '',
                fields: SUMMARY_AEL
            },
            {
                formID: 'event-ael',
                title: 'Event Details',
                fields: AEL_EVENT_FIELDS
            },
            {
                formID: 'organisation',
                title: 'Licensee Details',
                fields: LICENCE_ORGANISATION
            },
            {
                formID: 'applicant/filer-ael',
                title: 'Applicant/Company Details',
                fields: AEL_GENERAL_FIELDS
            },
            {
                formID: 'express-letter',
                title: 'Application Details',
                fields: NEW_EXPRESSLETTER_APPLICATION
            },
            {
                formID: 'aircraft-licence',
                title: 'Application Details',
                fields: NEW_AIRCRAFTLICENCE_APPLICATION
            },
            {
                formID: 'renew-aircraft-licence',
                title: 'Application Details',
                fields: RENEW_AIRCRAFTLICENCE_APPLICATION
            },
            {
                formID: 'cancel-aircraft-licence',
                title: 'Application Details',
                fields: CANCEL_AIRCRAFTLICENCE_APPLICATION
            },
            {
                formID: 'amend-aircraft-licence',
                title: 'Application Details',
                fields: AMEND_AIRCRAFTLICENCE_APPLICATION
            },
            {
                formID: 'payment-licence',
                title: 'Payment',
                fields: LICENCE_PAYMENT
            },
            {
                formID: 'contact-details',
                title: 'Contact Details',
                fields: CONTACT_DETAILS
            },
            {
                formID: 'localised-details',
                title: 'Application Details',
                fields: NEW_MYAPPLICATION_LOCALISEDNETWORK
            },
            {
                formID: 'licence_download',
                title: '',
                fields: Licence_DOWNLOAD
            },
            {
                formID: 'amateur-station',
                title: 'Application Details',
                fields: AMATEUR_STATION_APPLICATION
            },
            {
                formID: 'ship-station',
                title: 'Application Details',
                fields: SSL_APPLICATION
            },
            {
                formID: 'amend-ship-station',
                title: 'Application Details',
                fields: AMEND_SSL_APPLICATION
            },
            {
                formID: 'general-radio-com',
                title: 'Application Details',
                fields: GRS_APPLICATION
            },
            {
                formID: 'amend-general-radio-com',
                title: 'Application Details',
                fields: AMEND_GRS_APPLICATION
            },
            {
                formID: 'localised-radio-com',
                title: 'Application Details',
                fields: LRS_APPLICATION
            },
            {
                formID: 'amend-localised-radio-com',
                title: 'Application Details',
                fields: AMEND_LRS_APPLICATION
            },
            {
                formID: 'localised-private',
                title: 'Application Details',
                fields: LPN_APPLICATION
            },
            {
                formID: 'amend-localised-private',
                title: 'Application Details',
                fields: AMEND_LPN_APPLICATION
            },
            {
                formID: 'billing-details',
                title: 'Billing Details',
                fields: LICENCE_PAYMENT
            },
            {
                formID: 'public-mobile-network',
                title: 'Application Details',
                fields: PMN_APPLICATION
            },
            {
                formID: 'amend-public-mobile-network',
                title: 'Application Details',
                fields: AMEND_PMN_APPLICATION
            },
            {
                formID: 'satellite-comm-licence',
                title: 'Application Details',
                fields: SCS_APPLICATION
            },
            {
                formID: 'amend-satellite-comm-licence',
                title: 'Application Details',
                fields: AMEND_SCS_APPLICATION
            },
            {
                formID: 'ship-station-operator-certificate',
                title: 'Application Details',
                fields: SSOC_APPLICATION
            },
            {
                formID: 'amend-ship-station-operator-certificate',
                title: 'Application Details',
                fields: AMEND_SSOC_APPLICATION
            },
            {
                formID: 'telecommunication-dealers-individual',
                title: 'Application Details',
                fields: TDI_APPLICATION
            },
            {
                formID: 'amend-telecommunication-dealers-individual',
                title: 'Application Details',
                fields: AMEND_TDI_APPLICATION
            },
            {
                formID: 'telecommunication-dealers-class',
                title: 'Application Details',
                fields: TDC_APPLICATION
            },
            {
                formID: 'amend-telecommunication-dealers-class',
                title: 'Application Details',
                fields: AMEND_TDC_APPLICATION
            },
            {
                formID: 'general-equipment-registration',
                title: 'Application Details',
                fields: GER_APPLICATION
            },
            {
                formID: 'amend-general-equipment-registration',
                title: 'Application Details',
                fields: AMEND_GER_APPLICATION
            },
            {
                formID: 'general-equipment-registration-by-certification-bodies',
                title: 'Application Details',
                fields: GERCB_APPLICATION
            },
            {
                formID: 'amend-general-equipment-registration-by-certification-bodies',
                title: 'Application Details',
                fields: AMEND_GERCB_APPLICATION
            },
            {
                formID: 'simplified-equipment-registration',
                title: 'Application Details',
                fields: SER_APPLICATION
            },
            {
                formID: 'amend-simplified-equipment-registration',
                title: 'Application Details',
                fields: AMEND_SER_APPLICATION
            },
            {
                formID: 'enhanced-simplified-equipment-registration',
                title: 'Application Details',
                fields: ESER_APPLICATION
            },
            {
                formID: 'amend-enhanced-simplified-equipment-registration',
                title: 'Application Details',
                fields: AMEND_ESER_APPLICATION
            },
            {
                formID: 'confirmation-of-conformity',
                title: 'Application Details',
                fields: COFC_APPLICATION
            },
            {
                formID: 'amend-confirmation-of-conformity',
                title: 'Application Details',
                fields: AMEND_COFC_APPLICATION
            },
            {
                formID: 'fixed-wireless-network',
                title: 'Application Details',
                fields: FWN_APPLICATION
            },
            {
                formID: 'amend-fixed-wireless-network',
                title: 'Application Details',
                fields: AMEND_FWN_APPLICATION
            },
            {
                formID: 'wide-area-private-network',
                title: 'Application Details',
                fields: WPN_APPLICATION
            },
            {
                formID: 'amend-wide-area-private-network',
                title: 'Application Details',
                fields: AMEND_WPN_APPLICATION
            },
            {
                formID: 'experimental-station-licence',
                title: 'Application Details',
                fields: ESL_APPLICATION
            },
            {
                formID: 'amend-experimental-station-licence',
                title: 'Application Details',
                fields: AMEND_ESL_APPLICATION
            },
            {
                formID: 'special-purpose-station-licence',
                title: 'Application Details',
                fields: SPS_APPLICATION
            },
            {
                formID: 'amend-special-purpose-station-licence',
                title: 'Application Details',
                fields: AMEND_SPS_APPLICATION
            },
            {
                formID: 'technical-trial-with-use-of-frequency',
                title: 'Application Details',
                fields: TTF_APPLICATION
            },
            {
                formID: 'amend-technical-trial-with-use-of-frequency',
                title: 'Application Details',
                fields: AMEND_TTF_APPLICATION
            },
            {
                formID: 'temporary-use-of-radio-frequency',
                title: 'Application Details',
                fields: TUF_APPLICATION
            },
            {
                formID: 'amend-temporary-use-of-radio-frequency',
                title: 'Application Details',
                fields: AMEND_TUF_APPLICATION
            },
            {
                formID: 'services-based-operations-individual-licence',
                title: 'Application Details',
                fields: SBOI_APPLICATION
            },
            {
                formID: 'amend-services-based-operations-individual-licence',
                title: 'Application Details',
                fields: AMEND_SBOI_APPLICATION
            },
            {
                formID: 'technical-trial-without-use-of-frequency',
                title: 'Application Details',
                fields: TF_APPLICATION
            },
            {
                formID: 'amend-technical-trial-without-use-of-frequency',
                title: 'Application Details',
                fields: AMEND_TF_APPLICATION
            },
            {
                formID: 'cancel-licence-details',
                title: 'Cancellation Details',
                fields: CANCEL_LICENCE_APPLICATION
            },
            {
                formID: 'renew-licence-details',
                title: 'Application Details',
                fields: RENEW_LICENCE_APPLICATION
            },
            {
                formID: 'amend-licence-details',
                title: 'Application Details',
                fields: AMEND_LICENCE_APPLICATION
            },
            {
                formID: 'exhibition-of-telecommunication-equipment-without-frequency',
                title: 'Application Details',
                fields: EXB_APPLICATION
            },
            {
                formID: 'amend-exhibition-of-telecommunication-equipment-without-frequency',
                title: 'Application Details',
                fields: AMEND_EXB_APPLICATION
            },
            {
                formID: 'exhibition-of-telecommunication-equipment-with-frequency',
                title: 'Application Details',
                fields: EXBF_APPLICATION
            },
            {
                formID: 'amend-exhibition-of-telecommunication-equipment-with-frequency',
                title: 'Application Details',
                fields: AMEND_EXBF_APPLICATION
            },
            {
                formID: 'sboc-services',
                title: 'Services',
                fields: SBOC_APPLICATION_SERVICES
            },
            {
                formID: 'services-based-operations-class-licence',
                title: 'Application Details',
                fields: SBOC_APPLICATION
            },
            {
                formID: 'amend-services-based-operations-class-licence',
                title: 'Application Details',
                fields: AMEND_SBOC_APPLICATION
            }
        ]
    },
    {
        title: 'Licence',
        steps: [],
        caseType: 'IMDA-IRIS-Work-LICApplication-MNPP',
        actionSave: 'UpdateCase',
        actionCollect: 'EventClassification',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'summary',
                title: '',
                fields: SUMMARY_LICENCE
            },
            {
                formID: 'organisation',
                title: 'Licensee Details',
                fields: LICENCE_ORGANISATION
            },
            {
                formID: 'payment-licence',
                title: 'Payment',
                fields: LICENCE_PAYMENT
            },
            {
                formID: 'billing-details',
                title: 'Billing Details',
                fields: LICENCE_PAYMENT
            },
            {
                formID: 'printing-press-licence',
                title: 'Application Details',
                fields: PPL_APPLICATION
            },
            {
                formID: 'amend-printing-press-licence',
                title: 'Application Details',
                fields: AMEND_PPL_APPLICATION
            },
            {
                formID: 'renew-printing-press-licence',
                title: 'Application Details',
                fields: PPL_APPLICATION
            },
            {
                formID: 'newspaper-permit',
                title: 'Application Details',
                fields: NPP_APPLICATION
            },
            {
                formID: 'amend-newspaper-permit',
                title: 'Application Details',
                fields: AMEND_NPP_APPLICATION
            },
            {
                formID: 'cancel-licence-details',
                title: 'Cancellation Details',
                fields: CANCEL_LICENCE_APPLICATION
            },
            {
                formID: 'renew-licence-details',
                title: 'Application Details',
                fields: RENEW_LICENCE_APPLICATION
            },
            {
                formID: 'amend-licence-details',
                title: 'Application Details',
                fields: AMEND_LICENCE_APPLICATION
            }
        ]
    },
    {
        title: 'Licence',
        steps: [],
        caseType: 'IMDA-IRIS-Work-LICApplication-BCG',
        actionSave: 'UpdateCase',
        actionCollect: 'EventClassification',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'summary',
                title: '',
                fields: SUMMARY_LICENCE
            },
            {
                formID: 'organisation',
                title: 'Licensee Details',
                fields: LICENCE_ORGANISATION
            },
            {
                formID: 'payment-licence',
                title: 'Payment',
                fields: LICENCE_PAYMENT
            },
            {
                formID: 'billing-details',
                title: 'Billing Details',
                fields: LICENCE_PAYMENT
            },
            {
                formID: 'tv-receive-only-system-licence',
                title: 'Application Details',
                fields: TVRO_APPLICATION
            },
            {
                formID: 'amend-tv-receive-only-system-licence',
                title: 'Application Details',
                fields: AMEND_TVRO_APPLICATION
            },
            {
                formID: 'film-distribution-exhibition-licence',
                title: 'Application Details',
                fields: FDEL_APPLICATION
            },
            {
                formID: 'amend-film-distribution-exhibition-licence',
                title: 'Application Details',
                fields: AMEND_FDEL_APPLICATION
            },
            {
                formID: 'cancel-licence-details',
                title: 'Cancellation Details',
                fields: CANCEL_LICENCE_APPLICATION
            },
            {
                formID: 'renew-licence-details',
                title: 'Application Details',
                fields: RENEW_LICENCE_APPLICATION
            },
            {
                formID: 'amend-licence-details',
                title: 'Application Details',
                fields: AMEND_LICENCE_APPLICATION
            },
            {
                formID: 'internet-service-provider-licence',
                title: 'Application Details',
                fields: ISP_APPLICATION
            },
            {
                formID: 'amend-internet-service-provider-licence',
                title: 'Application Details',
                fields: AMEND_ISP_APPLICATION
            }
        ]
    },
    {
        title: 'Licence',
        steps: [],
        caseType: 'IMDA-IRIS-Work-LICApplication-TELE',
        actionSave: 'UpdateCase',
        actionCollect: 'EventClassification',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'summary',
                title: '',
                fields: SUMMARY_LICENCE
            },
            {
                formID: 'organisation',
                title: 'Licensee Details',
                fields: LICENCE_ORGANISATION
            },
            {
                formID: 'billing-details',
                title: 'Billing Details',
                fields: LICENCE_PAYMENT
            },
            {
                formID: 'telecommunication-cable-detection-worker-class-licence',
                title: 'Application Details',
                fields: TCDWCL_APPLICATION
            },
            {
                formID: 'amend-telecommunication-cable-detection-worker-class-licence',
                title: 'Application Details',
                fields: AMEND_TCDWCL_APPLICATION
            },
            {
                formID: 'telecommunication-wiring-installer-class-licence',
                title: 'Application Details',
                fields: TWICL_APPLICATION
            },
            {
                formID: 'amend-telecommunication-wiring-installer-class-licence',
                title: 'Application Details',
                fields: AMEND_TWICL_APPLICATION
            },
            {
                formID: 'telecommunication-wiring-contractor-class-licence',
                title: 'Application Details',
                fields: TWCCL_APPLICATION
            },
            {
                formID: 'amend-telecommunication-wiring-contractor-class-licence',
                title: 'Application Details',
                fields: AMEND_TWCCL_APPLICATION
            },
            {
                formID: 'cancel-licence-details',
                title: 'Cancellation Details',
                fields: CANCEL_LICENCE_APPLICATION
            },
            {
                formID: 'renew-licence-details',
                title: 'Application Details',
                fields: RENEW_LICENCE_APPLICATION
            },
            {
                formID: 'amend-licence-details',
                title: 'Application Details',
                fields: AMEND_LICENCE_APPLICATION
            }
        ]
    },

    {
        title: 'Licence',
        steps: [],
        caseType: 'IMDA-IRIS-Work-Licence',
        actionSave: 'UpdateCase',
        actionCollect: 'EventClassification',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'summary',
                title: '',
                fields: SUMMARY_LICENCE_TAB
            },
            {
                formID: 'summary-ael',
                title: '',
                fields: SUMMARY_AEL
            },
            {
                formID: 'event-ael',
                title: 'Event Details',
                fields: AEL_EVENT_FIELDS
            },
            {
                formID: 'applicant/filer-ael',
                title: 'Applicant/Company Details',
                fields: AEL_GENERAL_FIELDS
            },
            {
                formID: 'organisation',
                title: 'General Information',
                fields: MYLICENCE_LICENCE_ORGANISATION
            },
            {
                formID: 'express-letter',
                title: 'Licence Details',
                fields: EXPRESSLETTER
            },
            {
                formID: 'aircraft-licence',
                title: 'Licence Details',
                fields: AIRCRAFTLICENCE
            },
            {
                formID: 'payment-licence',
                title: 'Payment',
                fields: LICENCE_PAYMENT
            },
            {
                formID: 'cancelled-licence',
                title: 'Cancellation Details',
                fields: CANCELLED_LICENCE
            },
            {
                formID: 'localised-details',
                title: 'Details',
                fields: MYLICENCE_LOCALISEDNETWORK
            },
            {
                formID: 'contact-details',
                title: 'Contact Details',
                fields: CONTACT_DETAILS
            },
            {
                formID: 'licence_download',
                title: '',
                fields: MYLICENCE_DOWNLOAD
            },
            {
                formID: 'amateur-station',
                title: 'Licence Details',
                fields: AMATEUR_STATION_APPLICATION
            },
            {
                formID: 'ship-station',
                title: 'Licence Details',
                fields: SSL_LICENCE
            },
            {
                formID: 'ship-station',
                title: 'Licence Details',
                fields: AMEND_SSL_LICENCE
            },
            {
                formID: 'general-radio-com',
                title: 'Licence Details',
                fields: GRS_LICENCE
            },
            {
                formID: 'amend-general-radio-com',
                title: 'Licence Details',
                fields: AMEND_GRS_LICENCE
            },
            {
                formID: 'localised-radio-com',
                title: 'Licence Details',
                fields: LRS_LICENCE
            },
            {
                formID: 'amend-localised-radio-com',
                title: 'Licence Details',
                fields: AMEND_LRS_LICENCE
            },
            {
                formID: 'localised-private',
                title: 'Licence Details',
                fields: LPN_LICENCE
            },
            {
                formID: 'amend-localised-private',
                title: 'Licence Details',
                fields: AMEND_LPN_LICENCE
            },
            {
                formID: 'public-mobile-network',
                title: 'Licence Details',
                fields: PMN_LICENCE
            },
            {
                formID: 'amend-public-mobile-network',
                title: 'Licence Details',
                fields: AMEND_PMN_LICENCE
            },
            {
                formID: 'satellite-comm-licence',
                title: 'Licence Details',
                fields: SCS_LICENCE
            },
            {
                formID: 'amend-satellite-comm-licence',
                title: 'Licence Details',
                fields: AMEND_SCS_LICENCE
            },
            {
                formID: 'ship-station-operator-certificate',
                title: 'Licence Details',
                fields: SSOC_LICENCE
            },
            {
                formID: 'amend-ship-station-operator-certificate',
                title: 'Licence Details',
                fields: AMEND_SSOC_LICENCE
            },
            {
                formID: 'telecommunication-dealers-individual',
                title: 'Licence Details',
                fields: TDI_LICENCE
            },
            {
                formID: 'amend-telecommunication-dealers-individual',
                title: 'Licence Details',
                fields: AMEND_TDI_LICENCE
            },
            {
                formID: 'telecommunication-dealers-class',
                title: 'Licence Details',
                fields: TDC_LICENCE
            },
            {
                formID: 'amend-telecommunication-dealers-class',
                title: 'Licence Details',
                fields: AMEND_TDC_LICENCE
            },
            {
                formID: 'general-equipment-registration',
                title: 'Licence Details',
                fields: GER_LICENCE
            },
            {
                formID: 'amend-general-equipment-registration',
                title: 'Licence Details',
                fields: AMEND_GER_LICENCE
            },
            {
                formID: 'general-equipment-registration-by-certification-bodies',
                title: 'Licence Details',
                fields: GERCB_LICENCE
            },
            {
                formID: 'amend-general-equipment-registration-by-certification-bodies',
                title: 'Licence Details',
                fields: AMEND_GERCB_LICENCE
            },
            {
                formID: 'simplified-equipment-registration',
                title: 'Licence Details',
                fields: SER_LICENCE
            },
            {
                formID: 'amend-simplified-equipment-registration',
                title: 'Licence Details',
                fields: AMEND_SER_LICENCE
            },
            {
                formID: 'enhanced-simplified-equipment-registration',
                title: 'Licence Details',
                fields: ESER_LICENCE
            },
            {
                formID: 'amend-enhanced-simplified-equipment-registration',
                title: 'Licence Details',
                fields: AMEND_ESER_LICENCE
            },
            {
                formID: 'confirmation-of-conformity',
                title: 'Licence Details',
                fields: COFC_LICENCE
            },
            {
                formID: 'amend-confirmation-of-conformity',
                title: 'Licence Details',
                fields: AMEND_COFC_LICENCE
            },
            {
                formID: 'fixed-wireless-network',
                title: 'Licence Details',
                fields: FWN_LICENCE
            },
            {
                formID: 'amend-fixed-wireless-network',
                title: 'Licence Details',
                fields: AMEND_FWN_LICENCE
            },
            {
                formID: 'wide-area-private-network',
                title: 'Licence Details',
                fields: WPN_LICENCE
            },
            {
                formID: 'amend-wide-area-private-network',
                title: 'Licence Details',
                fields: AMEND_WPN_LICENCE
            },
            {
                formID: 'experimental-station-licence',
                title: 'Licence Details',
                fields: ESL_LICENCE
            },
            {
                formID: 'amend-experimental-station-licence',
                title: 'Licence Details',
                fields: AMEND_ESL_LICENCE
            },
            {
                formID: 'special-purpose-station-licence',
                title: 'Licence Details',
                fields: SPS_LICENCE
            },
            {
                formID: 'amend-special-purpose-station-licence',
                title: 'Licence Details',
                fields: AMEND_SPS_LICENCE
            },
            {
                formID: 'technical-trial-with-use-of-frequency',
                title: 'Licence Details',
                fields: TTF_LICENCE
            },
            {
                formID: 'amend-technical-trial-with-use-of-frequency',
                title: 'Licence Details',
                fields: AMEND_TTF_LICENCE
            },
            {
                formID: 'temporary-use-of-radio-frequency',
                title: 'Licence Details',
                fields: TUF_LICENCE
            },
            {
                formID: 'amend-temporary-use-of-radio-frequency',
                title: 'Licence Details',
                fields: AMEND_TUF_LICENCE
            },
            {
                formID: 'services-based-operations-individual-licence',
                title: 'Licence Details',
                fields: SBOI_LICENCE
            },
            {
                formID: 'amend-services-based-operations-individual-licence',
                title: 'Licence Details',
                fields: AMEND_SBOI_LICENCE
            },
            {
                formID: 'exhibition-of-telecommunication-equipment-without-frequency',
                title: 'Licence Details',
                fields: EXB_LICENCE
            },
            {
                formID: 'amend-exhibition-of-telecommunication-equipment-without-frequency',
                title: 'Licence Details',
                fields: AMEND_EXB_LICENCE
            },
            {
                formID: 'technical-trial-without-use-of-frequency',
                title: 'Licence Details',
                fields: TF_LICENCE
            },
            {
                formID: 'amend-technical-trial-without-use-of-frequency',
                title: 'Licence Details',
                fields: AMEND_TF_LICENCE
            },
            {
                formID: 'exhibition-of-telecommunication-equipment-with-frequency',
                title: 'Licence Details',
                fields: EXBF_LICENCE
            },
            {
                formID: 'amend-exhibition-of-telecommunication-equipment-with-frequency',
                title: 'Licence Details',
                fields: AMEND_EXBF_LICENCE
            },
            {
                formID: 'sboc-services',
                title: 'Services',
                fields: SBOC_LICENCE_SERVICES
            },
            {
                formID: 'services-based-operations-class-licence',
                title: 'Licence Details',
                fields: SBOC_LICENCE
            },
            {
                formID: 'amend-services-based-operations-class-licence',
                title: 'Licence Details',
                fields: AMEND_SBOC_LICENCE
            }
        ]
    },
    {
        title: 'Licence',
        steps: [],
        caseType: 'IMDA-IRIS-Work-Licence-MNPP',
        actionSave: 'UpdateCase',
        actionCollect: 'EventClassification',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'summary',
                title: '',
                fields: SUMMARY_LICENCE_TAB
            },
            {
                formID: 'payment-licence',
                title: 'Payment',
                fields: LICENCE_PAYMENT
            },
            {
                formID: 'cancelled-licence',
                title: 'Cancellation Details',
                fields: CANCELLED_LICENCE
            },
            {
                formID: 'organisation',
                title: 'General Information',
                fields: MYLICENCE_LICENCE_ORGANISATION
            },
            {
                formID: 'printing-press-licence',
                title: 'Licence Details',
                fields: PPL_LICENCE
            },
            {
                formID: 'amend-printing-press-licence',
                title: 'Licence Details',
                fields: AMEND_PPL_LICENCE
            },
            {
                formID: 'newspaper-permit',
                title: 'Licence Details',
                fields: NPP_LICENCE
            },
            {
                formID: 'amend-newspaper-permit',
                title: 'Licence Details',
                fields: AMEND_NPP_LICENCE
            }
        ]
    },
    {
        title: 'Licence',
        steps: [],
        caseType: 'IMDA-IRIS-Work-Licence-BCG',
        actionSave: 'UpdateCase',
        actionCollect: 'EventClassification',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'summary',
                title: '',
                fields: SUMMARY_LICENCE_TAB
            },
            {
                formID: 'billing-details',
                title: 'Billing Details',
                fields: LICENCE_PAYMENT
            },
            {
                formID: 'payment-licence',
                title: 'Payment',
                fields: LICENCE_PAYMENT
            },
            {
                formID: 'cancelled-licence',
                title: 'Cancellation Details',
                fields: CANCELLED_LICENCE
            },
            {
                formID: 'organisation',
                title: 'General Information',
                fields: MYLICENCE_LICENCE_ORGANISATION
            },
            {
                formID: 'tv-receive-only-system-licence',
                title: 'Application Details',
                fields: TVRO_LICENCE
            },
            {
                formID: 'amend-tv-receive-only-system-licence',
                title: 'Application Details',
                fields: AMEND_TVRO_LICENCE
            },
            {
                formID: 'film-distribution-exhibition-licence',
                title: 'Licence Details',
                fields: FDEL_LICENCE
            },
            {
                formID: 'amend-film-distribution-exhibition-licence',
                title: 'Application Details',
                fields: AMEND_FDEL_LICENCE
            },
            {
                formID: 'cancel-licence-details',
                title: 'Cancellation Details',
                fields: CANCEL_LICENCE_APPLICATION
            },
            {
                formID: 'internet-service-provider-licence',
                title: 'Application Details',
                fields: ISP_LICENCE
            },
            {
                formID: 'amend-internet-service-provider-licence',
                title: 'Application Details',
                fields: AMEND_ISP_LICENCE
            }
        ]
    },
    {
        title: 'Licence',
        steps: [],
        caseType: 'IMDA-IRIS-Work-Licence-TELE',
        actionSave: 'UpdateCase',
        actionCollect: 'EventClassification',
        actionReview: 'ReviewArtsScreen',
        forms: [
            {
                formID: 'summary',
                title: '',
                fields: SUMMARY_LICENCE_TAB
            },
            {
                formID: 'payment-licence',
                title: 'Payment',
                fields: LICENCE_PAYMENT
            },
            {
                formID: 'billing-details',
                title: 'Billing Details',
                fields: LICENCE_PAYMENT
            },
            {
                formID: 'cancelled-licence',
                title: 'Cancellation Details',
                fields: CANCELLED_LICENCE
            },
            {
                formID: 'organisation',
                title: 'General Information',
                fields: MYLICENCE_LICENCE_ORGANISATION
            },
            {
                formID: 'telecommunication-cable-detection-worker-class-licence',
                title: 'Application Details',
                fields: TCDWCL_LICENCE
            },
            {
                formID: 'amend-telecommunication-cable-detection-worker-class-licence',
                title: 'Application Details',
                fields: AMEND_TCDWCL_LICENCE
            },
            {
                formID: 'telecommunication-wiring-installer-class-licence',
                title: 'Application Details',
                fields: TWICL_LICENCE
            },
            {
                formID: 'amend-telecommunication-wiring-installer-class-licence',
                title: 'Application Details',
                fields: AMEND_TWICL_LICENCE
            },
            {
                formID: 'telecommunication-wiring-contractor-class-licence',
                title: 'Application Details',
                fields: TWCCL_LICENCE
            },
            {
                formID: 'amend-telecommunication-wiring-contractor-class-licence',
                title: 'Application Details',
                fields: AMEND_TWCCL_LICENCE
            },
            {
                formID: 'cancel-licence-details',
                title: 'Cancellation Details',
                fields: CANCEL_LICENCE_APPLICATION
            }
        ]
    },
    ...FILMS,
    ...FILMS_PENDING_KDM,
    ...RCA_PENDING_KDM,
    ...VIDEO_GAMES,
    ...DECLARATION_OF_INTERACTIVE_SOFTWARE
];

const CONFIRMATION_FORMS = [
    {
        caseType: 'IMDA-IRIS-Work-Arts',
        success: {
            headers: 'Your payment is successful!',
            subHeaders: 'Your application has been submitted successfully.'
        },
        summary: {
            isDisplayed: true,
            fields: [
                {
                    id: 'netsTxnRef',
                    label: 'Reference Number'
                },
                {
                    id: 'paymentMode',
                    label: 'Payment Mode'
                },
                {
                    id: 'netsTxnDtm',
                    label: 'Payment Date and Time'
                }
            ]
        },
        table: {
            columns: ['Event Ref No.', 'Description', 'Amount (S$)']
        }
    },
    {
        caseType: 'IMDA-IRIS-Work-LICApplication-ROE',
        success: {
            headers: 'Your application has been submitted successfully',
            subHeaders: ''
        },
        summary: {
            // ROE does not require payment/summary panel per requirement
            isDisplayed: false,
            fields: []
        },
        table: {
            // Display minimal confirmation: Application Number & Licence Name
            columns: ['Application Number', 'Licence Name']
        }
    },
    {
        caseType: 'IMDA-IRIS-Work-LICApplication-ACA',
        success: {
            headers: 'Your payment is successful!',
            subHeaders: 'Your application has been submitted successfully.'
        },
        summary: {
            isDisplayed: true,
            fields: [
                {
                    id: 'netsTxnRef',
                    label: 'Reference Number'
                },
                {
                    id: 'paymentMode',
                    label: 'Payment Mode'
                },
                {
                    id: 'netsTxnDtm',
                    label: 'Payment Date and Time'
                }
            ]
        },
        table: {
            columns: ['Application Number', 'Licence Name', 'Amount (S$)']
        }
    },
    {
        caseType: 'IMDA-IRIS-Work-LICApplication-ACA-AMEND',
        success: {
            headers: 'Your amendment application has been submitted successfully',
            subHeaders: ''
        },
        summary: {
            // ACA-AMEND does not require payment/summary panel (no payment for amendments)
            isDisplayed: false,
            fields: []
        },
        table: {
            // Display minimal confirmation: Application Number & Licence Name
            columns: ['Application Number', 'Licence Name']
        }
    },
    {
        caseType: 'IMDA-IRIS-Work-LICApplication-ACA-CANCEL',
        success: {
            headers: 'Your cancellation application has been submitted successfully',
            subHeaders: ''
        },
        summary: {
            // ACA-CANCEL does not require payment/summary panel
            isDisplayed: false,
            fields: []
        },
        table: {
            // Display minimal confirmation: Application Number & Licence Name
            columns: ['Application Number', 'Licence Name']
        }
    },
    {
        caseType: 'IMDA-IRIS-Work-LICApplication-ACA-RENEW',
        success: {
            headers: 'Your payment is successful!',
            subHeaders: 'Your renewal application has been submitted successfully.'
        },
        summary: {
            // ACA-RENEW requires payment (submitted after 3-month deadline)
            isDisplayed: true,
            fields: [
                {
                    id: 'netsTxnRef',
                    label: 'Reference Number'
                },
                {
                    id: 'paymentMode',
                    label: 'Payment Mode'
                },
                {
                    id: 'netsTxnDtm',
                    label: 'Payment Date and Time'
                }
            ]
        },
        table: {
            columns: ['Application Number', 'Licence Name', 'Amount (S$)']
        }
    },
    {
        caseType: 'IMDA-IRIS-Work-LICApplication-ACA-RENEW-NOPAY',
        success: {
            headers: 'Your renewal application has been submitted successfully',
            subHeaders: ''
        },
        summary: {
            // ACA-RENEW-NOPAY does not require payment (submitted within 3-month deadline)
            isDisplayed: false,
            fields: []
        },
        table: {
            // Display minimal confirmation: Application Number & Licence Name
            columns: ['Application Number', 'Licence Name']
        }
    },
    {
        caseType: 'IMDA-IRIS-Work-LICApplication-AA',
        success: {
            headers: 'Your application has been submitted successfully',
            subHeaders: ''
        },
        summary: {
            // AA does not require payment/summary panel per requirement
            isDisplayed: false,
            fields: []
        },
        table: {
            // Display minimal confirmation: Application Number & Licence Name
            columns: ['Application Number', 'Licence Name']
        }
    },
    {
        caseType: 'IMDA-IRIS-Work-LICApplication-AA-CANCEL',
        success: {
            headers: 'Your cancellation application has been submitted successfully',
            subHeaders: ''
        },
        summary: {
            // AA-CANCEL does not require payment/summary panel
            isDisplayed: false,
            fields: []
        },
        table: {
            // Display minimal confirmation: Application Number & Licence Name
            columns: ['Application Number', 'Licence Name']
        }
    },
    {
        caseType: 'IMDA-IRIS-Work-Publication',
        success: {
            headers: 'Your application has been submitted successfully',
            subHeaders: ''
        },
        summary: {
            isDisplayed: false,
            fields: []
        },
        table: {
            columns: ['Publication ID', 'Publication Type', 'Publication Title', 'Language', 'Physical Copy']
        }
    },
    {
        caseType: CASE_TYPE_ID.FILMS,
        success: {
            headers: 'Your application has been submitted successfully',
            subHeaders: ''
        },
        summary: {
            isDisplayed: false,
            fields: []
        },
        table: {
            columns: ['Case ID', 'Title', 'Romanised Title', 'Language', 'Format']
        }
    },
    {
        caseType: CASE_TYPE_ID.VIDEO_GAMES,
        success: {
            headers: 'Your application has been submitted successfully',
            subHeaders: ''
        },
        summary: {
            isDisplayed: false,
            fields: []
        },
        table: {
            columns: ['Case ID', 'Title', 'Romanised Title', 'Publisher', 'Platform']
        }
    },
    {
        caseType: CASE_TYPE_ID.INTERACTIVE_SOFTWARE,
        success: {
            headers: 'Your application has been submitted successfully',
            subHeaders: ''
        },
        summary: {
            isDisplayed: false,
            fields: []
        },
        table: {
            columns: ['Case ID', 'Title', 'Romanised Title', 'Language', 'Format']
        }
    }
];

const PAYMENT_FIELDS = [
    {
        id: 'receipt',
        label: 'Receipt'
    },
    {
        id: 'dateTime',
        label: 'Payment Date and Time'
    },
    {
        id: 'agency',
        label: 'Agency'
    },
    {
        id: 'paidVia',
        label: 'Paid Via'
    }
];

const DECLARATION_P1 =
    'all the information given in this application form is true and correct and I am aware that legal action may be taken against me if I had knowingly provided false information; and';
const DECLARATION_P1A =
    'I declare that all the information given in this application form is true and correct and I am aware that legal action may be taken against me if I had knowingly provided false information.';
const DECLARATION_P2 =
    'I have procured all necessary authorisation, consents or licences from the relevant copyright owners, or their lawful assigns or licensees for the arts entertainments to be staged.';
const DECLARATION_FILMS_B = 'any film to be submitted to the IMDA is complete and complies with the submission requirements; and';
const DECLARATION_P3 =
    'I agree that in any legal proceedings, I shall not dispute the authenticity or accuracy of any statements, confirmations, records, acknowledgements, information recorded in or produced in this application.';
const DECLARATION_P4 =
    'I agree that in any legal proceedings, I shall not dispute the authenticity or accuracy of any statements, confirmations, records, acknowledgements, information recorded in or produced in this declaration.';
const DECLARATION_FILMS_C = 'the content of this submission is identical to that previously approved by the IMDA.';
const DECLARATION_FILMS_CA =
    'the content of the main feature title in this submission is identical to that previously approved by the IMDA. ';
const DECLARATION_VIDEO_GAMES_B =
    'any video game / rating material to be submitted to the IMDA is complete and complies with the submission requirements.';
const DECLARATION_INTERACTIVE_SOFTWARE_B =
    'the content of the interactive software does not contain any of the elements listed in the Guidelines for Interactive Software.';
const DECLARATION_ACA = [
    'In applying to the Controller of Certification Authorities in Singapore to operate as an accredited Certification Authority under the Act and the Regulations, I declare that all the above information provided by the company is true and complete.',
    'In the event that any of the information provided by the company is found to be false or misleading, the Controller reserves the right to take appropriate enforcement action against the company under the Act and/or the Regulations (including, without limitation, cancelling or suspending the accreditation of the company).',
    'The Controller reserves the right to reject any application without providing any reason.'
];

const DECLARATION_RCA_1 =
    'I, <applicant name>, undertake to pay the prescribed fees related to Co-Classfication as set out in the Films (Fees) Regulations.';
const DECLARATION_RCA_2 =
    'I declare that all the information given in this submission form is true and correct and I am aware that legal action may be taken against me if I had knowingly provided false information.';
const DECLARATION_RCA_3 =
    'I further declare that I have assessed the content in accordance with the current Film Classification Guidelines and any physical media to be submitted to IMDA is complete and complies with the Submission Guidelines.';
const DECLARATION_RCA_4 =
    'I agree that in any legal proceedings, I shall not dispute the authenticity or accuracy of any statements, confirmations, records, acknowledgments, information recorded in or produced from IMDA IRIS.';

const NOTE_TO_APPLICANT_RCA_1 =
    'Any media received after 5:30 pm will only be registered on the next working day which is considered as Day Zero. The service standards start the working day after (Day One).';
const NOTE_TO_APPLICANT_RCA_2 =
    'All physical media not claimed, after one month from the notification of application being processed, will be disposed by the IMDA and all outstanding payment must be made good to the IMDA.';

export {
    // sections
    SECT_TYPE,
    SECT_FILER,
    SECT_APPLICANT,
    SECT_PE,
    SECT_EVENT_DETAILS,
    SECT_EVENT_VENUE,
    SECT_PERFORMER,
    SECT_DOCS,
    SECT_PE_ON_GOING,
    SECT_PERFORMER_ON_GOING,
    SECT_ORGANISATION,
    SECT_EVENT_ON_GOING,
    SECT_PUB_DETAILS,
    CONTACT_APPLICANT,
    CONTACT_PUB,
    // other submodule sections
    OTHER_SECT_TYPE,
    OTHER_SECT_FILER,
    OTHER_SECT_APPLICANT,
    OTHER_SECT_ADDRESS,
    OTHER_SECT_COMPANY,

    // fields
    GENERAL_FIELDS,
    EVENT_FIELDS,
    EVENT_PE_FIELDS,
    EVENT_PERFORMER_FIELDS,
    ORGANISATION_FIELDS,
    PUBLICATION_FIELDS,
    CONTACT_DETAILS_FIELDS,
    PUB_CONTACT_DETAILS_FIELDS,
    ROE_APPLICATION_FIELDS,
    ACA_APPLICATION_FIELDS,
    ACA_GENERAL_FIELDS,
    AA_APPLICATION_FIELDS,
    AA_GENERAL_FIELDS,
    AA_CONTACT_DETAILS,
    OTHER_GENERAL_FIELDS,
    OTHER_CONTACT_DETAILS,

    // common
    INDUSTRIES,
    CONFIRMATION_FORMS,
    PAYMENT_FIELDS,
    DECLARATION_P1,
    DECLARATION_P1A,
    DECLARATION_P2,
    DECLARATION_P3,
    DECLARATION_P4,
    DECLARATION_FILMS_B,
    DECLARATION_FILMS_C,
    DECLARATION_FILMS_CA,
    DECLARATION_VIDEO_GAMES_B,
    DECLARATION_INTERACTIVE_SOFTWARE_B,
    DECLARATION_ACA,
    DECLARATION_RCA_1,
    DECLARATION_RCA_2,
    DECLARATION_RCA_3,
    DECLARATION_RCA_4,
    NOTE_TO_APPLICANT_RCA_1,
    NOTE_TO_APPLICANT_RCA_2
};
